const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3000';

async function fetchAPI(endpoint, options = {}) {
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    credentials: 'include',
  });
  
  if (!response.ok && response.status !== 401) {
    // Try to parse error message from JSON response
    try {
      const errorData = await response.json();
      throw new Error(errorData.error || `API error: ${response.statusText}`);
    } catch (parseError) {
      // If JSON parsing fails, use status text
      throw new Error(`API error: ${response.statusText}`);
    }
  }
  
  return response;
}

export const api = {
  // Auth
  getAuthStatus: () => fetchAPI('/api/auth/status').then(r => r.json()),
  loginWithGoogle: () => fetchAPI('/api/auth/google').then(r => r.json()),
  handleGoogleCallback: (code) => fetchAPI('/api/auth/google/callback', {
    method: 'POST',
    body: JSON.stringify({ code }),
  }).then(r => r.json()),
  logout: () => fetchAPI('/api/auth/logout', { method: 'POST' }).then(r => r.json()),

  // Settings
  getSettings: () => fetchAPI('/api/settings').then(r => r.json()),
  updateSettings: (settings) => fetchAPI('/api/settings', {
    method: 'PUT',
    body: JSON.stringify(settings),
  }).then(r => r.json()),
  uploadFavicon: (file) => {
    const formData = new FormData();
    formData.append('favicon', file);
    return fetch(`${API_BASE}/api/settings/favicon`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    }).then(r => r.json());
  },

  // Categories
  getCategories: () => fetchAPI('/api/categories').then(r => r.json()),
  createCategory: (category) => fetchAPI('/api/categories', {
    method: 'POST',
    body: JSON.stringify(category),
  }).then(r => r.json()),
  updateCategory: (id, category) => fetchAPI(`/api/categories/${id}`, {
    method: 'PUT',
    body: JSON.stringify(category),
  }).then(r => r.json()),
  deleteCategory: (id) => fetchAPI(`/api/categories/${id}`, {
    method: 'DELETE',
  }).then(r => r.json()),

  // Budgets
  getBudgets: (month) => fetchAPI(`/api/budgets/${month}`).then(r => r.json()),
  updateBudget: (budget) => fetchAPI('/api/budgets', {
    method: 'POST',
    body: JSON.stringify(budget),
  }).then(r => r.json()),
  regenerateBudget: (month) => fetchAPI(`/api/budgets/regenerate/${month}`, {
    method: 'POST',
  }).then(r => r.json()),

  // Transactions
  getTransactions: (month) => fetchAPI(`/api/transactions?month=${month}`).then(r => r.json()),
  getRecentMerchants: () => fetchAPI('/api/transactions/merchants').then(r => r.json()),
  createTransaction: (transaction) => fetchAPI('/api/transactions', {
    method: 'POST',
    body: JSON.stringify(transaction),
  }).then(r => r.json()),
  updateTransaction: (id, transaction) => fetchAPI(`/api/transactions/${id}`, {
    method: 'PUT',
    body: JSON.stringify(transaction),
  }).then(r => r.json()),
  deleteTransaction: (id) => fetchAPI(`/api/transactions/${id}`, {
    method: 'DELETE',
  }).then(r => r.json()),
  exportTransactions: (filters) => {
    return fetch(`${API_BASE}/api/transactions/export`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(filters),
    }).then(r => r.blob());
  },

  // Spending
  getSpending: (month) => fetchAPI(`/api/spending/${month}`).then(r => r.json()),
};
